import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Tooltip
} from '@mui/material';
import Pagination from "react-js-pagination";
import { view_Stock_Transactions } from '../../../services/stock_service';
import { format } from 'date-fns';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { makeStyles } from '@mui/styles';
import Loading_animation_view from '../../loading_animation_view/loading_animation_view';
import { get_all_services } from '../../../services/for_allServices';

const useStyles = makeStyles({
  dialogTitle: {
    backgroundColor: '#f5f5f5',
    borderBottom: '1px solid #ddd',
  },
  tableHeader: {
    backgroundColor: '#f5f5f5',
  },
  tableCell: {
    fontWeight: 'bold',
  },
  inIcon: {
    color: 'green',
  },
  outIcon: {
    color: 'red',
  },
 
});

const Stock_transactions_table = ({ open, onClose, suppliers, categories }) => {
  const classes = useStyles();
  const [transactions, setTransactions] = useState(null);
  const [serviceNames, setServiceNames] = useState({});

  const [page, setPage] = useState(1);

  const [perPage] = useState(10);
  const [totalItemsCount, setTotalItemsCount] = useState(0);

  useEffect(() => {
    fetchTransactions(page);
  }, [page]);


  useEffect(() => {
    const fetchServiceNames = async () => {
      const services_list = await get_all_services().then((response)=>{return response.data});
      for (const srv_data of services_list) {
          setServiceNames((prev) => ({ ...prev, [srv_data.id]: srv_data.fullName }));
      }
    };
    fetchServiceNames();
  }, []);


  function get_category_name_by_id(id_category) {
    let tmp_name = "";
    for (let category of categories) {
      if (category.id_category == parseInt(id_category)) tmp_name = category.name;
    }
    return tmp_name;
  }

  function get_supplier_by_id(id) {
    let tmp_supplier = "";
    for (let supplier of suppliers) {
      if (supplier.id == id) { tmp_supplier = supplier.parentCompany; break; }
    }
    return tmp_supplier;
  }

  const fetchTransactions = async (pageNumber = 1) => {
    try {
      await view_Stock_Transactions(pageNumber, perPage).then((response) => {
       //  console.log("transactions", response);

        setTransactions(response.data.data);
        setTotalItemsCount(response.data.total);
       // setPage(response.data.current_page);

      }).catch((error) => {
       //  console.log(error.response);
      })
    } catch (error) {
      console.error('Error fetching transactions:', error);
    }
  };


  const handlePageChange = (value) => {
   //  console.log("Clicked page:", value); // <-- this should be a number!
    setPage(value);
    //fetchTransactions(value);
  };


  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle className={classes.dialogTitle}>Les transactions du stock</DialogTitle>
      <DialogContent dividers>
        {transactions!=null
        ?<Paper style={{ margin: '20px 0', padding: '20px' }}>
          <TableContainer>
            <Table>
              <TableHead className={classes.tableHeader}>
                <TableRow>
                  <TableCell className={classes.tableCell}>Référence du produit</TableCell>
                  <TableCell className={classes.tableCell}>Code du produit</TableCell>
                  <TableCell className={classes.tableCell}>Categorie</TableCell>
                  <TableCell className={classes.tableCell}>Quantité</TableCell>
                  <TableCell className={classes.tableCell}>Prix</TableCell>
                  <TableCell className={classes.tableCell}>Type</TableCell>
                  <TableCell className={classes.tableCell}>Demandeur</TableCell>
                  <TableCell className={classes.tableCell}>Fournisseur</TableCell>
                  <TableCell className={classes.tableCell}>Fait le</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {transactions.map((transaction) => (
                  <TableRow key={transaction.id}>
                    <TableCell>{transaction.product_reference}</TableCell>
                    <TableCell>{transaction.product_code}</TableCell>
                    <TableCell>{get_category_name_by_id(transaction.product_category)}</TableCell>
                    <TableCell>{transaction.product_quantity}</TableCell>
                    <TableCell>{transaction.product_price}</TableCell>
                    <TableCell>
                      {transaction.add_to_stock ? (
                        <Tooltip title="Entrante">
                          <ArrowDownwardIcon className={classes.inIcon} />
                        </Tooltip>
                      ) : (
                        <Tooltip title="Sortante">
                          <ArrowUpwardIcon className={classes.outIcon} />
                        </Tooltip>
                      )}
                    </TableCell>
                    <TableCell>
                      {serviceNames[transaction.requester] || 'Aucun'}
                    </TableCell>
                    <TableCell>{get_supplier_by_id(transaction.supplier)}</TableCell>
                    <TableCell>{format(new Date(transaction.created_at), 'dd/MM/yyyy HH:mm:ss')}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <div className="pagination_container" style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }} >
            <Pagination
              totalItemsCount={totalItemsCount}
              itemsCountPerPage={perPage}
              activePage={page}
              onChange={handlePageChange}
              color="primary"
              pageRangeDisplayed={4}
            />
          </div>
        </Paper>
        :<Loading_animation_view />
        }
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" className="submit_but cancel_but">
          Fermer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Stock_transactions_table;
